var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeelsLikeTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998,3.9999c0-1.104,0.896-2,2-2c1.105,0,2,0.896,2,2s-0.895,2-2,2 C16.8958,5.9999,15.9998,5.1039,15.9998,3.9999z M22.7498,13.7499c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75 c0-1.667-0.424-3.218-1.25-4.631v5.881v6.25c0,0.414-0.335,0.75-0.75,0.75c-0.414,0-0.75-0.336-0.75-0.75v-6.25h-1v6.25 c0,0.414-0.335,0.75-0.75,0.75c-0.414,0-0.75-0.336-0.75-0.75v-6.25v-5.882c-0.825,1.414-1.25,2.966-1.25,4.632 c0,0.414-0.336,0.75-0.75,0.75c-0.414,0-0.75-0.336-0.75-0.75c0-2.365,0.723-4.534,2.148-6.448c0.148-0.198,0.373-0.288,0.602-0.289 c0-0.013,4-0.013,4-0.013c0.229,0.014,0.454,0.105,0.602,0.302C22.0268,9.2149,22.7498,11.3839,22.7498,13.7499z M8.9998,13.0209 v-8.021c0-1.656-1.343-3-3-3c-1.657,0-3,1.344-3,3v8.021c-1.208,0.916-2,2.347-2,3.979c0,2.763,2.238,5,5,5c2.762,0,5-2.237,5-5 C10.9998,15.3679,10.2078,13.9369,8.9998,13.0209z M6.9997,9h-2V4.9999c0-0.5513,0.4482-1,1-1s1,0.4487,1,1V9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelsLikeTomorrowio);
export default __webpack_public_path__ + "static/media/feels-like-tomorrowio.319beac67a333f6dddc293ea86c10e4d.svg";
export { ForwardRef as ReactComponent };